import { Injectable } from '@angular/core';
import { IAdapter } from '@drl/core/api/adapters/i-adapter';
import { IpsTranslateService } from '@drl/core/localization/ips-translate.service';
import { UserSessionStoreService as StoreService } from '@drl/core/store/user-session-store.service';
import { prescriptionStatusMap } from '@drl/shared/utility/patients-caregiver-utility.enum';
import { Prescriptions } from 'src/app/main/patients/shared/models';

@Injectable()
export class SinglePrescriptionAdapter implements IAdapter<Prescriptions> {
  constructor(private readonly store: StoreService, protected readonly translateSvc: IpsTranslateService) { }

  adaptToModel(resp: Prescriptions): Prescriptions {
    resp.status =
      resp.status &&
      prescriptionStatusMap(this.translateSvc.translate)[parseInt(resp.status)];
    if (resp.medicines && resp.medicines.length > 0) {
      resp.medicines.forEach((med) => {
        if (med.reminderTime) {
          const [hours, minutes, sec] = (med.reminderTime as string).split(':');
          const reminderDate = new Date();
          reminderDate.setHours(parseInt(hours, 0), parseInt(minutes) || 0, parseInt(sec) || 0);   // Set the hours
          med.reminderTime = reminderDate;
        }
      });
    }
    return resp;
  }
  // sonarignore:start
  adaptFromModel(data: Prescriptions): any {
    delete data.uniqId;
    delete data.prescDateTimeString;
    delete data.patientName;
    delete data.mobile;
    delete data.patientExternalId;
    delete data.searchBy;
    delete data.doctorUserId;
    data.prescriptionDate = data.prescriptionDate;
    if (data.medicines) {
      data.medicines.forEach((med: any) => {
        delete med.editable;
        med.instructions = med.description;
        delete med.description;
        if (med.frequency) {
          med.frequency = Number(med.frequency);
        }
        if (med.duration) {
          med.duration = Number(med.duration);
        }
        if (med.dosage) {
          med.dosage = (med.dosage);
        }

      });
    }
    return data;
    // sonarignore:end
  }
}
